import React, { useEffect, useRef } from "react"
import { navigate } from "gatsby"
import { useLocation } from "@reach/router"
import { ScrollTrigger } from "gsap/ScrollTrigger"

const PageTransition = ({ children, className }) => {
    const transitionRef = useRef(null)
    const { pathname } = useLocation()
    useEffect(() => {
        const transitionWrapper = transitionRef.current
        if (!transitionWrapper) return
        const normalise = path => {
            try {
                return new URL(path, window.location.origin).pathname.replace(/\/$/, "") || "/"
            } catch {
                return ""
            }
        }
        function fadeOutPage(event, path) {
            event.preventDefault()
            if (normalise(pathname) === normalise(path)) return
            window.dispatchEvent(new CustomEvent("page-transition-start"))
            document.querySelector(".masthead")?.classList.remove("scaled")
            document.body.classList.remove("menu-open");
            transitionWrapper.classList.remove("fade--in")
            transitionWrapper.classList.add("fade--out")
            setTimeout(() => navigate(path), 350)
        }
        function fadeInPage() {
            if (transitionWrapper.classList.contains("fade--out")) {
                transitionWrapper.classList.remove("fade--out")
            }
            transitionWrapper.classList.add("fade--in")
            requestAnimationFrame(() => {
                window.scrollTo(0, 0)
                requestAnimationFrame(() => {
                    window.scrollTo(0, 0)
                    ScrollTrigger.refresh()
                })
            })
            setTimeout(() => {
                window.scrollTo(0, 0)
                ScrollTrigger.refresh()
            }, 400)
        }
        fadeInPage()
        const links = document.querySelectorAll("a")
        links.forEach(link => {
            if (link.hasAttribute("target")) return
            const path = link.getAttribute("href")
            if (!path || path.startsWith("mailto:") || path.startsWith("tel:")) return
            const handler = e => fadeOutPage(e, path)
            link.__ptHandler = handler
            link.addEventListener("click", handler)
        })
        return () => {
            links.forEach(link => {
                if (link.__ptHandler) {
                    link.removeEventListener("click", link.__ptHandler)
                    delete link.__ptHandler
                }
            })
        }
    }, [pathname])
    return (
        <div className={`page--transition fade--in${className ? ` ${className}` : ""}`} ref={transitionRef}>
            {children}
        </div>
    )
}

export default PageTransition
